import { computed } from 'vue';
import { usePage } from '@inertiajs/vue3';
import { BasicButton, PropertiesInterface, FooterLogo, Picture } from '~/types';
import WebsiteLogoImage from '@/img/logo.png';

export const useSettings = () => {
  const { props } = usePage<PropertiesInterface>();

  const websiteLogo = computed<string>(() => props.website_logo || WebsiteLogoImage);
  const websiteTimezone = computed<string>(() => props.website_timezone || 'UTC');
  const featuredCategoryId = computed<number>(() => props.featured_category_id);
  const headlinesCategoryId = computed<number>(() => props.headlines_category_id);

  const newsPageTitle = computed<string | undefined>(() => props.news_page_settings?.news_page_title || undefined);
  const newsPageImage = computed<Picture | undefined>(
    () => props.news_page_settings?.news_page_featured_image || undefined
  );

  const headerButtons = computed<BasicButton[] | undefined>(() => props.header_settings?.buttons);
  const footerLogos = computed<FooterLogo[] | undefined>(() => props.footer_logos);

  return {
    featuredCategoryId,
    footerLogos,
    headerButtons,
    headlinesCategoryId,
    newsPageImage,
    newsPageTitle,
    websiteLogo,
    websiteTimezone,
  };
};
